function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
import { Card, CardContent } from './card';
export function SadFaceIcon(_0) {
    let { color = '#465380' } = _0, props = _object_without_properties(_0, [
        "color"
    ]);
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "56",
        height: "56",
        viewBox: "0 0 56 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M19.507 35.77C19.0367 36.165 18.7411 36.7295 18.6843 37.341C18.6275 37.9526 18.8141 38.5619 19.2037 39.0367C19.3996 39.273 19.6401 39.4683 19.9116 39.6114C20.1831 39.7546 20.4801 39.8428 20.7857 39.8709C21.0913 39.8991 21.3995 39.8667 21.6926 39.7756C21.9857 39.6845 22.2579 39.5365 22.4937 39.34C24.0535 38.0824 25.9967 37.3966 28.0003 37.3966C30.004 37.3966 31.9472 38.0824 33.507 39.34C33.7428 39.5365 34.015 39.6845 34.3081 39.7756C34.6012 39.8667 34.9093 39.8991 35.2149 39.8709C35.5206 39.8428 35.8176 39.7546 36.0891 39.6114C36.3606 39.4683 36.6011 39.273 36.797 39.0367C37.1865 38.5619 37.3732 37.9526 37.3164 37.341C37.2596 36.7295 36.964 36.165 36.4937 35.77C34.086 33.8347 31.0895 32.7796 28.0003 32.7796C24.9112 32.7796 21.9147 33.8347 19.507 35.77ZM21.0003 25.6667C21.4618 25.6667 21.913 25.5298 22.2967 25.2735C22.6804 25.0171 22.9795 24.6526 23.1561 24.2263C23.3327 23.7999 23.3789 23.3308 23.2888 22.8781C23.1988 22.4255 22.9766 22.0098 22.6503 21.6834C22.3239 21.3571 21.9082 21.1349 21.4555 21.0449C21.0029 20.9548 20.5338 21.001 20.1074 21.1776C19.681 21.3542 19.3166 21.6533 19.0602 22.037C18.8039 22.4207 18.667 22.8719 18.667 23.3334C18.667 23.9522 18.9128 24.5457 19.3504 24.9833C19.788 25.4209 20.3815 25.6667 21.0003 25.6667ZM28.0003 4.66669C23.3854 4.66669 18.8742 6.03516 15.037 8.59906C11.1999 11.163 8.20919 14.8071 6.44315 19.0707C4.6771 23.3343 4.21502 28.0259 5.11535 32.5521C6.01567 37.0784 8.23795 41.236 11.5012 44.4992C14.7644 47.7624 18.922 49.9847 23.4482 50.885C27.9745 51.7853 32.666 51.3233 36.9296 49.5572C41.1932 47.7912 44.8374 44.8005 47.4013 40.9633C49.9652 37.1262 51.3337 32.6149 51.3337 28C51.3337 24.9358 50.7301 21.9017 49.5575 19.0707C48.3849 16.2398 46.6662 13.6676 44.4995 11.5009C42.3328 9.33416 39.7606 7.61544 36.9296 6.44283C34.0987 5.27022 31.0645 4.66669 28.0003 4.66669V4.66669ZM28.0003 46.6667C24.3084 46.6667 20.6994 45.5719 17.6297 43.5208C14.56 41.4697 12.1674 38.5543 10.7546 35.1434C9.34175 31.7326 8.97209 27.9793 9.69235 24.3583C10.4126 20.7374 12.1904 17.4113 14.801 14.8007C17.4116 12.1901 20.7377 10.4123 24.3587 9.69203C27.9796 8.97177 31.7329 9.34143 35.1438 10.7543C38.5546 12.1671 41.47 14.5597 43.5211 17.6294C45.5722 20.6991 46.667 24.3081 46.667 28C46.667 32.9507 44.7003 37.6987 41.1997 41.1994C37.699 44.7 32.951 46.6667 28.0003 46.6667V46.6667ZM35.0003 21C34.5388 21 34.0877 21.1369 33.704 21.3933C33.3203 21.6496 33.0212 22.0141 32.8446 22.4404C32.668 22.8668 32.6218 23.3359 32.7118 23.7886C32.8019 24.2412 33.0241 24.6569 33.3504 24.9833C33.6767 25.3096 34.0925 25.5318 34.5451 25.6219C34.9978 25.7119 35.4669 25.6657 35.8933 25.4891C36.3196 25.3125 36.684 25.0134 36.9404 24.6297C37.1968 24.246 37.3337 23.7948 37.3337 23.3334C37.3337 22.7145 37.0878 22.121 36.6503 21.6834C36.2127 21.2459 35.6192 21 35.0003 21Z",
            fill: color
        })
    }));
}
export function DangerIcon(_0) {
    let { color = '#FF7B7B' } = _0, props = _object_without_properties(_0, [
        "color"
    ]);
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12 7C11.7348 7 11.4804 7.10536 11.2929 7.29289C11.1054 7.48043 11 7.73478 11 8V12C11 12.2652 11.1054 12.5196 11.2929 12.7071C11.4804 12.8946 11.7348 13 12 13C12.2652 13 12.5196 12.8946 12.7071 12.7071C12.8946 12.5196 13 12.2652 13 12V8C13 7.73478 12.8946 7.48043 12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7ZM12 15C11.8022 15 11.6089 15.0586 11.4444 15.1685C11.28 15.2784 11.1518 15.4346 11.0761 15.6173C11.0004 15.8 10.9806 16.0011 11.0192 16.1951C11.0578 16.3891 11.153 16.5673 11.2929 16.7071C11.4327 16.847 11.6109 16.9422 11.8049 16.9808C11.9989 17.0194 12.2 16.9996 12.3827 16.9239C12.5654 16.8482 12.7216 16.72 12.8315 16.5556C12.9414 16.3911 13 16.1978 13 16C13 15.7348 12.8946 15.4804 12.7071 15.2929C12.5196 15.1054 12.2652 15 12 15ZM21.71 7.56L16.44 2.29C16.2484 2.10727 15.9948 2.00368 15.73 2H8.27C8.00523 2.00368 7.75163 2.10727 7.56 2.29L2.29 7.56C2.10727 7.75163 2.00368 8.00523 2 8.27V15.73C2.00368 15.9948 2.10727 16.2484 2.29 16.44L7.56 21.71C7.75163 21.8927 8.00523 21.9963 8.27 22H15.73C15.9948 21.9963 16.2484 21.8927 16.44 21.71L21.71 16.44C21.8927 16.2484 21.9963 15.9948 22 15.73V8.27C21.9963 8.00523 21.8927 7.75163 21.71 7.56V7.56ZM20 15.31L15.31 20H8.69L4 15.31V8.69L8.69 4H15.31L20 8.69V15.31Z",
            fill: color
        })
    }));
}
// Layout Component
export function ErrorPageLayout(param) {
    let { children, logo, className } = param;
    return /*#__PURE__*/ _jsxs("div", {
        "data-slot": "error-page-layout",
        className: cn('flex flex-col', className),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                "data-slot": "error-page-header",
                className: "flex items-center p-8",
                children: [
                    logo && /*#__PURE__*/ _jsx("div", {
                        "data-slot": "error-page-logo",
                        children: logo
                    }),
                    /*#__PURE__*/ _jsx("hr", {
                        className: "ml-8 flex-1 h-px border-0 border-b border-border"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                "data-slot": "error-page-content-container",
                className: "flex w-full h-[80vh] justify-center items-center",
                children: children
            })
        ]
    });
}
// Content Component
export function ErrorContent(param) {
    let { icon: Icon, title, subtitle, description, image, action, className } = param;
    return /*#__PURE__*/ _jsx(Card, {
        "data-slot": "error-content",
        className: cn('w-full max-w-[778px] bg-card rounded-2xl', className),
        children: /*#__PURE__*/ _jsx(CardContent, {
            className: "p-6 md:px-10 md:py-6",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-8 items-center",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col space-y-4",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Icon, {
                                        "data-slot": "error-content-icon",
                                        className: "w-8 h-8 text-destructive shrink-0"
                                    }),
                                    /*#__PURE__*/ _jsx("h1", {
                                        className: "text-3xl md:text-[32px] font-bold leading-tight text-destructive m-0",
                                        children: title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("h2", {
                                className: "text-base font-medium leading-relaxed text-muted-foreground mt-4",
                                children: subtitle
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-sm text-muted-foreground/80 mt-1",
                                children: description
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "mt-8",
                                children: action
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex justify-center md:justify-end",
                        children: /*#__PURE__*/ _jsx("div", {
                            "data-slot": "error-content-image",
                            className: "max-w-full",
                            children: image
                        })
                    })
                ]
            })
        })
    });
}
